import { render, staticRenderFns } from "./TransactionsList.vue?vue&type=template&id=2e9712b1&scoped=true"
import script from "./TransactionsList.vue?vue&type=script&lang=ts"
export * from "./TransactionsList.vue?vue&type=script&lang=ts"
import style0 from "./TransactionsList.vue?vue&type=style&index=0&id=2e9712b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9712b1",
  null
  
)

export default component.exports